import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Eventdetails = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Event Details</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Event Details</li>
          </ul>
        </div>
      </section>

      <div className="ul-container ul-section-spacing">
        <div className="row gx-0 gy-4 flex-column-reverse flex-lg-row">

          <div className="col-lg-4">
            <div className="ul-inner-sidebar">

              <div className="ul-inner-sidebar-widget ul-inner-sidebar-search">
                <h3 className="ul-inner-sidebar-widget-title">Search</h3>
                <div className="ul-inner-sidebar-widget-content">
                  <form action="#" className="ul-blog-search-form">
                    <input
                      type="search"
                      name="blog-search"
                      id="ul-blog-search"
                      placeholder="Search Here"
                    />
                    <button type="submit">
                      <span className="icon"><i className="flaticon-search"></i></span>
                    </button>
                  </form>
                </div>
              </div>

              <div className="ul-inner-sidebar-widget categories">
                <h3 className="ul-inner-sidebar-widget-title">Categories</h3>
                <div className="ul-inner-sidebar-widget-content">
                  <div className="ul-inner-sidebar-categories">
                    <Link to="/donations">Charity <span>(08)</span></Link>
                    <Link to="/donations">Crowdfunding <span>(11)</span></Link>
                    <Link to="/donations">Industries <span>(18)</span></Link>
                    <Link to="/donations">Innovations <span>(11)</span></Link>
                    <Link to="/donations">Technology <span>(07)</span></Link>
                  </div>
                </div>
              </div>

              <div className="ul-inner-sidebar-widget posts">
                <h3 className="ul-inner-sidebar-widget-title">Recent Posts</h3>
                <div className="ul-inner-sidebar-widget-content">
                  <div className="ul-inner-sidebar-posts">

                    <div className="ul-inner-sidebar-post">
                      <div className="img">
                        <img
                          src="/assets/new-img/new/group-of-happy-volunteers-sorting-donations-while-2024-12-13-21-32-21-utc.jpg"
                          alt="Post Image"
                        />
                      </div>

                      <div className="txt">
                        <h4 className="title">
                          <Link to="/donations"
                            >Understanding Diabetes: A Bilingual Guide</Link
                          >
                        </h4>
                        <span className="date"> <span>May 12, 2025</span></span>
                      </div>
                    </div>

                    <div className="ul-inner-sidebar-post">
                      <div className="img">
                        <img
                          src="/assets/new-img/new/food-distribution-volunteers-help-needy-2025-02-19-10-27-15-utc.jpg"
                          alt="Post Image"
                        />
                      </div>

                      <div className="txt">
                        <h4 className="title">
                          <Link to="/donations"
                            >Understanding Diabetes: A Bilingual Guide</Link
                          >
                        </h4>
                        <span className="date"> <span>May 12, 2025</span></span>
                      </div>
                    </div>

                    <div className="ul-inner-sidebar-post">
                      <div className="img">
                        <img
                          src="/assets/new-img/new/group-of-volunteers-sorting-garbage-2025-04-02-09-20-13-utc.JPG"
                          alt="Post Image"
                        />
                      </div>

                      <div className="txt">
                        <h4 className="title">
                          <Link to="/donations"
                            >Understanding Diabetes: A Bilingual Guide</Link
                          >
                        </h4>
                        <span className="date"> <span>May 12, 2025</span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="ul-inner-sidebar-widget tags">
                <h3 className="ul-inner-sidebar-widget-title">Tag Cloud</h3>
                <div className="ul-inner-sidebar-widget-content">
                  <div className="ul-inner-sidebar-tags">
                    <Link to="/donations">Crowdfunding</Link>
                    <Link to="/donations">Innovations</Link>
                    <Link to="/donations">Justice</Link>
                    <Link to="/donations">Lead</Link>
                    <Link to="/donations">Startup</Link>
                    <Link to="/donations">Technology</Link>
                    <Link to="/donations">Market</Link>
                    <Link to="/donations">Court</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="ul-event-details ul-donation-details">
              <div className="ul-event-details-img">
                <img
                  src="/assets/new-img/new/volunteers-planting-trees-in-the-park-2025-09-06-19-31-12-utc.jpg"
                  alt="Image"
                />
              </div>
              <div className="ul-event-details-infos">

                <div className="ul-event-details-info">
                  <span className="icon"><i className="flaticon-account"></i></span>
                  <span className="text">By Admin</span>
                </div>

                <div className="ul-event-details-info">
                  <span className="icon"><i className="flaticon-price-tag"></i></span>
                  <span className="text">Donation</span>
                </div>
              </div>
              <h2 className="ul-event-details-title">
                Manager Disapproved of the Most Recent Work.
              </h2>
              <p className="ul-event-details-descr">
                I must explain to you how all this mistaken idea of pleasure and
                praising pain was born and I will give you a complete account of
                the system, and expound the actual teachings of the great
                explorer of the truth, the master-builder of human happiness. No
                one rejects, dislikes, or avoids pleasure itself, because it is
                pleasure, but because those who do not know how to pursue
                pleasure rationally encounter consequences that are extremely
                painful.
              </p>
              <p>
                Nor again is there anyone who loves or pursues or desires to
                obtain pain of itself, because it is pain, but because
                occasionally circumstances occur in which toil and pain can
                procure him some great pleasure. To take a trivial example,
                which of us ever undertakes laborious physical exercise.
              </p>
              <h3 className="ul-event-details-inner-title">Our Event Mission</h3>
              <p className="ul-event-details-descr">
                Cast obscure badger jeep quail congenialy when changed as cat
                jeepers affectionate thus facilisi goodness this far like ipsum
                dolor sit amet, consectetur adipisicing elits eiusmod tempo
                incididunt et laboret dolore magna aliqua enim ad minim. Eveniet
                in vulputate esse molestie consequat, illum Eveniet in vulputate
                esse molestie dolore .
              </p>
              <ul className="ul-event-details-list">
                <li>Creating and editing content</li>
                <li>Workflows, reporting, and content organization</li>
                <li>User & role-based administration and security</li>
                <li>Flexibility, scalability, and performance and analysis</li>
                <li>Multilingual content capabilities</li>
              </ul>
              <h3 className="ul-event-inner-title">See Our Locations</h3>
              <div className="ul-event-details-map">
                <iframe
                  title="Event Location Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6138.2324980070525!2d90.43028998193272!3d23.825180986890324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c63855fb64f1%3A0xb613b7b7edbcab99!2sBlock%20G%2C%20Dhaka!5e0!3m2!1sen!2sbd!4v1736745125068!5m2!1sen!2sbd"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              <h3 className="ul-event-inner-title">Contact us</h3>
              <p>
                Your email address will not be published. Required fields are
                marked *
              </p>
              <form action="#" className="ul-contact-form ul-form">
                <div className="row row-cols-2 row-cols-xxs-1 ul-bs-row">
                  <div className="col">
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        id="ul-contact-name"
                        placeholder="Your Name"
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        id="ul-contact-email"
                        placeholder="Email Address"
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <input
                        type="tel"
                        name="phone"
                        id="ul-contact-phone"
                        placeholder="Phone Number"
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <input
                        type="text"
                        name="subject"
                        id="ul-contact-subject"
                        placeholder="Subject"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        id="ul-contact-msg"
                        placeholder="Type your message"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-12">
                    <button className="ul-btn">
                      <i
                        className="flaticon-fast-forward-double-right-arrows-symbol"
                      ></i>
                      Get in Touch
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>

      <Footer />
    </>
  );
};

export default Eventdetails;
